const INTERCOM_HOSTS: ReadonlySet<string> = new Set([
  "dashboard.promptlayer.com",
  "dashboard.eu.promptlayer.com",
]);

export const isIntercomHost = (hostname: string): boolean => INTERCOM_HOSTS.has(hostname);
